import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

/**
 * The signature "HAYAT line" — a continuous vertical line that draws itself
 * as the visitor scrolls. Calm, precise, in champagne gold.
 */
export const HayatLine = () => {
  const { scrollYProgress } = useScroll();
  const pathLength = useSpring(scrollYProgress, {
    stiffness: 80,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-y-0 start-4 z-40 hidden lg:block"
    >
      <svg width="2" height="100%" viewBox="0 0 2 100" preserveAspectRatio="none" className="h-full w-[2px]">
        <line x1="1" y1="0" x2="1" y2="100" stroke="hsl(var(--sand))" strokeWidth="2" />
        <motion.line
          x1="1"
          y1="0"
          x2="1"
          y2="100"
          stroke="hsl(var(--champagne-gold))"
          strokeWidth="2"
          style={{ pathLength, scaleY: pathLength, transformOrigin: "top" }}
        />
      </svg>
    </div>
  );
};
